import React from 'react';
import {useSelector} from 'react-redux';
import './index.scss';

export default function Wrapper({children, hidden}) {
  const sidebarStatus = useSelector(
    state => state?.rootReducer?.inspectionSlice?.sidebar,
  );

  return (
    <main
      className={`wrapper ${hidden ? 'hidden' : ''} ${
        sidebarStatus ? 'active' : ''
      }`}
    >
      {children}
    </main>
  );
}
